var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._b({staticClass:"MileageInput",attrs:{"type":"tel"},domProps:{"value":_vm.localValue},on:{"input":_vm.handleInput}},'input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }